// extracted by mini-css-extract-plugin
export default {"bannerWrapper":"Baner_bannerWrapper__ryj4Q","bannerImg":"Baner_bannerImg__l7kAx","bannerDescription":"Baner_bannerDescription__gch7T"};